import { OutputDeliverableMetricsResponse } from '@/types/composer-dashboard';
import { apiRequest } from '@/utils/api-request';

export const getOutputDeliverableMetrics = async (
  orgId: string,
  labelIds?: string[],
): Promise<OutputDeliverableMetricsResponse> => {
  const params = labelIds?.length
    ? '?' +
      labelIds.map((id) => `label_ids=${encodeURIComponent(id)}`).join('&')
    : '';

  const response = await apiRequest<OutputDeliverableMetricsResponse>({
    url: `/api/v1/orgs/${orgId}/admin/metrics/output-deliverables${params}`,
    method: 'GET',
    target: 'workflow',
  });

  if (response.detail) {
    throw new Error(response.detail);
  }

  if (!response.data) {
    throw new Error('Failed to fetch output deliverable metrics');
  }

  return response.data;
};
